// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__1fcRm","subheader":"ReorderModal_subheader__1V4Dx","listWrap":"ReorderModal_listWrap__1QDkp"};